import * as React from 'react';
import { isEmpty, has } from 'lodash';

export const useCheckWindowCMS = () => {
  const windowCMS = window._CMS_;
  React.useEffect(() => {
    if (isEmpty(windowCMS) || isEmpty(windowCMS.ENV)) {
      throw Error('Error: Env is invalid');
    }

    if (
      !has(windowCMS, 'ENABLE_FILE_UPLOAD') ||
      (has(windowCMS, 'ENABLE_FILE_UPLOAD') && typeof windowCMS.ENABLE_FILE_UPLOAD !== 'boolean')
    ) {
      throw Error('Error: `ENABLE_FILE_UPLOAD` in Env is missing/invalid');
    }

    if (
      !has(windowCMS, 'MAX_FILE_UPLOAD_SIZE_IN_MB') ||
      (has(windowCMS, 'MAX_FILE_UPLOAD_SIZE_IN_MB') && typeof windowCMS.MAX_FILE_UPLOAD_SIZE_IN_MB !== 'number')
    ) {
      throw Error('Error: `MAX_FILE_UPLOAD_SIZE_IN_MB` in Env is missing/invalid');
    }

    if (
      !has(windowCMS, 'ALLOWED_FILE_EXTENSIONS') ||
      (has(windowCMS, 'ALLOWED_FILE_EXTENSIONS') && typeof windowCMS.ALLOWED_FILE_EXTENSIONS !== 'object')
    ) {
      throw Error('Error: `ALLOWED_FILE_EXTENSIONS` in Env is missing/invalid');
    }

    if (
      !has(windowCMS, 'API') ||
      (has(windowCMS, 'API') && typeof windowCMS.API !== 'object') ||
      !has(windowCMS.API, 'baseurl') ||
      (has(windowCMS.API, 'baseurl') && typeof windowCMS.API.baseurl !== 'string')
    ) {
      throw Error('Error: `API.baseurl` in Env is missing/invalid');
    }
  }, [windowCMS]);

  return { maxFileSize: windowCMS.MAX_FILE_UPLOAD_SIZE_IN_MB };
};
